import { CapsuleGeometry, Mesh, MeshStandardMaterial } from 'three';

function createMesh2() {
  // https://threejs.org/docs/#api/en/geometries/CapsuleGeometry
  // 胶囊测定法
  // CapsuleGeometry(radius : Float, length : Float, capSegments : Integer, radialSegments : Integer)
  const geometry = new CapsuleGeometry( 1, 0, 12, 18 ); 
  const material = new MeshStandardMaterial( {color: 0x00ff00} ); 
  const capsule = new Mesh( geometry, material );
  return capsule;
}

export { createMesh2 };